import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M11.558 3.558a.625.625 0 0 1 .884 0l5 5a.625.625 0 1 1-.884.884L12 4.884 7.442 9.442a.625.625 0 1 1-.884-.884l5-5Zm-5 11a.625.625 0 0 1 .884 0L12 19.116l4.558-4.558a.625.625 0 1 1 .884.884l-5 5a.625.625 0 0 1-.884 0l-5-5a.625.625 0 0 1 0-.884Z"
    />
  </svg>
`;
